import React, { useContext, useEffect, useState } from "react";

import NewDailyUpdateButton from "components/buttons/NewDailyUpdateButton";
import FriendsDailyUpdateComponent from "components/memoriesComponents/FriendsDailyUpdateComponent";
import NewDailyUpdateInputArea from "components/memoriesComponents/NewDailyUpdateInputArea";
import { CurrentUserContext } from "App";
import defaultAvatar from "assets/sampleAvatar.png";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3080";

export default function MemoriesPage() {
  const { currentUser, setCurrentUser } = useContext(CurrentUserContext);
  const [dailyPostElements, setDailyPostElements] = useState([]);
  const [open, setOpen] = useState(true);
  const [streak, setStreak] = useState({ current_streak: 0, longest_streak: 0 });

  // Fetch streak info
  useEffect(() => {
    fetch(`${API_URL}/api/daily-update-streak`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((r) => r.json())
      .then((r) => {
        if (r.message === "success" && r.streak) {
          setStreak(r.streak);
        }
      })
      .catch((err) => console.error("Error fetching streak:", err));
  }, [currentUser.token]);

  // get followed account posts on component render
  useEffect(() => {
    fetch(`${API_URL}/getDailyUpdates`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
      },
    })
      .then((r) => r.json())
      .then((r) => {
        if (r.message === "success") {
          console.log(r.dailyUpdates);
          const elements = r.dailyUpdates?.map((post) => {
            return (
              <FriendsDailyUpdateComponent
                key={post.daily_update_id}
                dailyUpdateId={post.daily_update_id}
                postBody={post.body}
                postTitle={post.title}
                postMedia={post.media_src}
                numberOfLikes={post.number_of_likes}
                username={post.username}
                createdBy={post.created_by}
                onDelete={(id) => setDailyPostElements((prev) => prev.filter((el) => el.key !== String(id)))}
                avatar={post.avatar && post.avatar !== "sampleAvatar.png"
                  ? post.avatar
                  : defaultAvatar}
              />
            );
          });
          setDailyPostElements(elements);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  // Callback to refresh streak after a new post
  const onPostCreated = (newStreak) => {
    if (newStreak) {
      setStreak(newStreak);
    }
  };

  return (
    <>
      <div style={{ paddingTop: "1rem" }}>
        {/* STREAK INDICATOR */}
        <div style={streakStyles.container}>
          <div style={streakStyles.badge}>
            <span style={streakStyles.flame} role="img" aria-label="streak">
              {streak.current_streak > 0 ? (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="#f7d000" stroke="#f7d000" strokeWidth="1">
                  <path d="M12 23c-3.866 0-7-3.134-7-7 0-3.037 2.574-6.267 5-8.5.406-.374 1.044-.07 1.02.487C10.9 10.5 12 11 13 10c1-1 1.5-2.5 1.5-4.5 0-.553.476-.94.97-.687C18.319 6.294 20 9.5 20 13.5 20 18.194 16.411 23 12 23z"/>
                  <path d="M12 23c-1.657 0-3-1.343-3-3 0-1.657 1.5-3 3-4 1.5 1 3 2.343 3 4 0 1.657-1.343 3-3 3z" fill="#ff8c00"/>
                </svg>
              ) : (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="1.5">
                  <path d="M12 23c-3.866 0-7-3.134-7-7 0-3.037 2.574-6.267 5-8.5.406-.374 1.044-.07 1.02.487C10.9 10.5 12 11 13 10c1-1 1.5-2.5 1.5-4.5 0-.553.476-.94.97-.687C18.319 6.294 20 9.5 20 13.5 20 18.194 16.411 23 12 23z"/>
                </svg>
              )}
            </span>
            <span style={{
              ...streakStyles.count,
              color: streak.current_streak > 0 ? "#f7d000" : "#666",
            }}>
              {streak.current_streak}
            </span>
            <span style={streakStyles.label}>
              {streak.current_streak === 1 ? "day" : "days"}
            </span>
          </div>
          {streak.longest_streak > 0 && streak.longest_streak > streak.current_streak && (
            <span style={streakStyles.best}>
              Best: {streak.longest_streak}
            </span>
          )}
        </div>

        {/* BUTTON AND UPDATE INPUT AREA COLLAPSE */}
        <div className="d-flex flex-column align-items-center" style={{ width: "100%" }}>
          {/* New User Post Button */}
          <div className="d-flex flex-column align-items-center" style={{ width: "100%" }}>
            <NewDailyUpdateButton
              onClick={() => setOpen(!open)}
              isOpen={open}
            />
            {open ? (
              ""
            ) : (
              <NewDailyUpdateInputArea
                setOpen={setOpen}
                open={open}
                setDailyPostElements={setDailyPostElements}
                onPostCreated={onPostCreated}
              />
            )}
          </div>
        </div>
      </div>
      {/* FRIENDS DAILY UPDATE CONTAINER */}
      <div style={{ padding: "0", width: "100%" }}>
        <div id="daily-update-area" style={feedGridStyle}>
          {dailyPostElements}
        </div>
      </div>
    </>
  );
}

const feedGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: "10px",
  maxWidth: "600px",
  margin: "0 auto",
  paddingTop: "0.75rem",
};

const streakStyles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.75rem",
    marginBottom: "0.75rem",
  },
  badge: {
    display: "flex",
    alignItems: "center",
    gap: "0.35rem",
    backgroundColor: "rgba(50,43,64,0.8)",
    borderRadius: "20px",
    padding: "0.35rem 0.85rem",
    border: "1px solid rgba(185,151,255,0.2)",
  },
  flame: {
    display: "flex",
    alignItems: "center",
  },
  count: {
    fontSize: "1rem",
    fontWeight: "700",
  },
  label: {
    fontSize: "0.75rem",
    color: "#999",
    marginLeft: "0.1rem",
  },
  best: {
    fontSize: "0.7rem",
    color: "#666",
    fontStyle: "italic",
  },
};
